import { GameStatus } from '../../core/constants.js';
import gameState from '../../core/game-state.js';
import { STATE_PATHS } from '../../shared/constants/state-paths.js';

import {
  isAwaitingPromptAfterReset,
  setAwaitingPromptAfterReset,
} from './tutorial-session-state.js';
import { getOnboardingStatus } from './tutorial-storage.js';

let statusWatcherUnsubscribe = null;
let onboardingStatusSnapshot = null;
let promptRequestCallback = null;

export function initializeStatusWatcher(onPromptRequested) {
  promptRequestCallback = onPromptRequested;
  if (statusWatcherUnsubscribe) {
    if (onboardingStatusSnapshot === null) {
      const snapshot = getOnboardingStatus();
      onboardingStatusSnapshot = snapshot?.status ?? null;
    }
    return;
  }

  const snapshot = getOnboardingStatus();
  onboardingStatusSnapshot = snapshot?.status ?? null;
  statusWatcherUnsubscribe = gameState.subscribe((event) => {
    handleGameStateEvent(event);
  });
}

function handleGameStateEvent(event) {
  if (!event || !event.path) {
    return;
  }

  if (
    event.path === STATE_PATHS.SETTINGS_TUTORIAL_ONBOARDING ||
    event.path === STATE_PATHS.SETTINGS_TUTORIAL_ONBOARDING_STATUS
  ) {
    const previousStatus = onboardingStatusSnapshot;
    const snapshot = getOnboardingStatus();
    const nextStatus = snapshot?.status ?? null;
    onboardingStatusSnapshot = nextStatus;
    if (nextStatus === 'pending' && previousStatus && previousStatus !== 'pending') {
      setAwaitingPromptAfterReset(true);
      maybeRequestPrompt();
    }
    return;
  }

  if (event.path === STATE_PATHS.CORE_STATUS) {
    maybeRequestPrompt();
  }
}

function maybeRequestPrompt() {
  if (!isAwaitingPromptAfterReset()) {
    return;
  }
  const coreStatus = gameState.getState(STATE_PATHS.CORE_STATUS);
  if (coreStatus !== GameStatus.Title) {
    return;
  }
  setAwaitingPromptAfterReset(false);
  promptRequestCallback?.();
}

export function teardownStatusWatcher() {
  if (statusWatcherUnsubscribe) {
    statusWatcherUnsubscribe();
    statusWatcherUnsubscribe = null;
  }
  onboardingStatusSnapshot = null;
  promptRequestCallback = null;
  setAwaitingPromptAfterReset(false);
}
